export const factoryAbi = [
  {
    type: 'function',
    name: 'createSplitter',
    inputs: [
      { name: 'payees', type: 'address[]' },
      { name: 'shares_', type: 'uint256[]' },
      { name: 'feeBps', type: 'uint256' },
      { name: 'owner', type: 'address' },
    ],
    outputs: [{ name: '', type: 'address' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    name: 'splittersForPayee',
    inputs: [{ name: 'payee', type: 'address' }],
    outputs: [{ name: '', type: 'address[]' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    name: 'protocolFeeRecipient',
    inputs: [],
    outputs: [{ name: '', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    name: 'MIN_PROTOCOL_FEE_BPS',
    inputs: [],
    outputs: [{ name: '', type: 'uint256' }],
    stateMutability: 'view',
  },
] as const;
